import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getAuditLogEventDetailsPath = (id = ':id') => urlHelper(`/audit-log/${id}`);
